import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import classNames from 'classnames';
import { getBreadcrumbsJsonLd } from 'components/CmsPage/utils';
import Breadcrumbs from 'components/Breadcrumbs';
import cmsPageStyles from '../../../CmsPage/CmsPage.scss';

const pageBreadcrumbsDefaultPropBreadcrumbs = { breadcrumbs: [] };

const PageBreadcrumbs = ({
  className,
  breadcrumbs = pageBreadcrumbsDefaultPropBreadcrumbs,
  title = '',
}) => {
  const metadata =
    !!breadcrumbs.breadcrumbs.length && getBreadcrumbsJsonLd(breadcrumbs.breadcrumbs, title);

  return (
    <>
      {metadata && (
        <Helmet>
          <script type="application/ld+json" data-testid="seo-metadata-breadcrumbs">
            {JSON.stringify(metadata)}
          </script>
        </Helmet>
      )}
      <div className={classNames(cmsPageStyles.header, className)}>
        {breadcrumbs && <Breadcrumbs {...breadcrumbs} />}
      </div>
    </>
  );
};

PageBreadcrumbs.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  breadcrumbs: PropTypes.shape({
    breadcrumbs: PropTypes.arrayOf(
      PropTypes.shape({ name: PropTypes.string, path: PropTypes.string }),
    ),
  }),
};

export default PageBreadcrumbs;
